export const translations = {
    "ar": () => import(/*webpackChunkName: 'calendar-settings-t-ar'*/"../translations/ar"),
    "de": () => import(/*webpackChunkName: 'calendar-settings-t-de'*/"../translations/de"),
    "en": () => import(/*webpackChunkName: 'calendar-settings-t-en'*/"../translations/en"),
    "es": () => import(/*webpackChunkName: 'calendar-settings-t-es'*/"../translations/es"),
    "fr": () => import(/*webpackChunkName: 'calendar-settings-t-fr'*/"../translations/fr"),
    "id": () => import(/*webpackChunkName: 'calendar-settings-t-id'*/"../translations/id"),
    "ru": () => import(/*webpackChunkName: 'calendar-settings-t-ru'*/"../translations/ru"),
    "tr": () => import(/*webpackChunkName: 'calendar-settings-t-tr'*/"../translations/tr"),
    "zh-cht": () => import(/*webpackChunkName: 'calendar-settings-t-zh-cht'*/"../translations/zh-cht"),
    "zh-cn": () => import(/*webpackChunkName: 'calendar-settings-t-zh-cn'*/"../translations/zh-cn"),
    "vi": () => import(/*webpackChunkName: 'calendar-settings-t-vi'*/"../translations/vi"),
    "fa": () => import(/*webpackChunkName: 'calendar-settings-t-fa'*/"../translations/fa"),
    "pt": () => import(/*webpackChunkName: 'calendar-settings-t-pt'*/"../translations/pt"),
    "cs": () => import(/*webpackChunkName: 'calendar-settings-t-cs'*/"../translations/cs"),
}

export const fetchLocalizations = async (store) => {
    const storeCulture = store.getState().config.culture
    const culture = storeCulture ? storeCulture.toLowerCase() : 'en'

    const currentCulture = translations.hasOwnProperty(culture) ? culture : 'en'

    const fetchedTranslations = await translations[currentCulture]()
      .catch(() => {
        console.error('Could not fetch translations')
        return null
      })

    return { translations: fetchedTranslations.default }
}
